// Espelha StatusDiaAjudaCustoEnum do backend (serializado como número)
export enum StatusDia {
  Futuro = 1,
  Hoje = 2,
  ComRegistro = 3,
  SemRegistroSolicitavel = 4,
  SolicitacaoPendente = 5,
  SemRegistroForaJanela = 6,
}

// Espelha StatusSolicitacaoAjusteEnum
export enum StatusSolicitacao {
  Pendente = 1,
  Aprovada = 2,
  Reprovada = 3,
}

export interface CalendarioDia {
  data: string // yyyy-MM-dd
  status: StatusDia
  temRegistro: boolean
  registroPago: boolean
  podeRegistrarHoje: boolean
  podeSolicitarAjuste: boolean
  justificativaSolicitacao?: string | null
}

export interface Calendario {
  ano: number
  mes: number
  dias: CalendarioDia[]
}

export interface SolicitacaoAjuste {
  idSolicitacaoAjusteAjudaCusto: number
  pessoaId: number
  pessoaNome?: string | null
  data: string
  justificativa: string
  status: StatusSolicitacao
  statusDescricao: string
  motivoReprova?: string | null
  dataAvaliacao?: string | null
  dataCadastro: string
}

export interface ValorDiaria {
  idValorDiariaAjudaCusto?: number
  valor: number
  dataInicioVigencia: string
  dataFimVigencia: string
  podeEditar: boolean
}

export interface RelatorioPessoa {
  pessoaId: number
  pessoaNome: string
  quantidadeDias: number
  valorTotal: number
  datas: string[]
}

export interface RelatorioPreview {
  dataInicio: string
  dataFim: string
  pessoas: RelatorioPessoa[]
  valorTotalGeral: number
  quantidadePessoas: number
  quantidadeDias: number
  datasSemVigencia: string[]
}

export interface LoteItem {
  pessoaId: number
  pessoaNome?: string | null
  quantidadeDias: number
  valorTotalPessoa: number
  datas: string[]
}

export interface Lote {
  idLotePagamentoAjudaCusto: number
  dataInicioPeriodo: string
  dataFimPeriodo: string
  dataGeracao: string
  valorTotal: number
  quantidadePessoas: number
  quantidadeDias: number
  itens: LoteItem[]
}

export interface LotesResumo {
  totalLotes: number
  valorTotalPago: number
  totalPessoas: number
  totalDias: number
}

export interface LotesResultado {
  lotes: Lote[]
  resumo: LotesResumo
}

export interface PessoaOption {
  idPessoa: number
  nome: string
}

export interface SolicitacaoFiltros {
  status?: StatusSolicitacao
  pessoaId?: number
  dataInicio?: string
  dataFim?: string
}
